const columns = [
  {
    title: "站内导航",
    links: [
      { label: "最新入口", href: "#entrances" },
      { label: "访问指南", href: "#guide" },
      { label: "失效排查", href: "#issues" },
      { label: "热播合集", href: "#collections" },
    ],
  },
  {
    title: "帮助中心",
    links: [
      { label: "更新日志", href: "#updates" },
      { label: "常见问题", href: "#faq" },
      { label: "地址失效怎么办", href: "#issues" },
      { label: "手机访问方法", href: "#guide" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "站点介绍", href: "#top" },
      { label: "免责声明", href: "#disclaimer" },
      { label: "使用条款", href: "#disclaimer" },
      { label: "意见反馈", href: "#faq" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer id="disclaimer" className="w-full bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-play-circle-fill text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">久久视频</span>
            </div>
            <p className="mt-4 max-w-sm text-xs leading-relaxed text-background-100/80">
              久久视频网址导航页，持续整理最新地址与防屏蔽入口，帮助你在链接变动时快速找到可用的访问地址。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["官网", "最新地址", "入口", "防屏蔽"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-background-100/25 px-3 py-1 text-xs text-background-100/85"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-bold text-background-50">
                <a href="#top" className="cursor-pointer">
                  {col.title}
                </a>
              </h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={`${col.title}-${link.label}`}>
                    <a
                      href={link.href}
                      className="text-xs text-background-100/80 transition-colors hover:text-background-50"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-lg border border-background-100/15 bg-primary-900/60 p-5">
          <p className="text-xs leading-relaxed text-background-100/75">
            免责声明：本页面仅提供网址导航与访问方式指引，不提供、不存储任何影视内容，也不涉及注册、登录与付费。页面所展示的外部地址均来自公开信息，请遵守所在地法律法规，内容相关权益请以对应站点说明为准。
          </p>
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-3 border-t border-background-100/15 pt-6 text-xs text-background-100/70 sm:flex-row sm:items-center">
          <p>© 2026 久久视频网址导航 · 仅供访问索引参考</p>
          <p className="flex items-center gap-2">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-time-line"></i>
            </span>
            页面最近更新：2026-10-10
          </p>
        </div>
      </div>
    </footer>
  );
}